import React, { useState, useEffect } from 'react';
import './bot.css';

const Bot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [minimized, setMinimized] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [conversation, setConversation] = useState([]);
  const [currentStepId, setCurrentStepId] = useState('welcome');

// const steps = [
//   {
//     id: "welcome",
//     message: "Hello! 👋 Welcome to Eye Care Institute – College of Optometry & Vision Science.",
//     trigger: "intro",
//   },
//   {
//     id: "intro",
//     message:
//       "We offer nationally recognized NVQ and professional optometry programs designed for a successful career in eye care.",
//     trigger: "main_menu",
//   },

//   /* ================= MAIN MENU ================= */
//   {
//     id: "main_menu",
//     options: [
//       { value: "courses", label: "📘 View Courses", trigger: "course_menu" },
//       { value: "location", label: "📍View Location", trigger: "location_info" },
//       { value: "contact", label: "☎️ Contact Details", trigger: "contact_info" },
//     ],
//   },

//   /* ================= COURSE MENU ================= */
//   {
//     id: "course_menu",
//     message: "Please select a course to view details:",
//     trigger: "course_options",
//   },
//   {
//     id: "course_options",
//     options: [
//       { value: "nvq3", label: "Ophthalmic Optician (NVQ Level 03)", trigger: "nvq3_info" },
//       { value: "assistant", label: "Certificate in Ophthalmic Assistant", trigger: "assistant_info" },
//       { value: "dip", label: "Diploma in Optometry (NVQ Level 04)", trigger: "dip_info" },
//       { value: "hdip", label: "Higher Diploma in Optometry (NVQ Level 06)", trigger: "hdip_info" },
//       { value: "fellow", label: "Fellowship Courses", trigger: "fellow_info" },
//       { value: "workshop", label: "Fellowship Workshops", trigger: "workshop_info" },
//       { value: "nvq35", label: "NVQ Level 3 & 5", trigger: "nvq35_info" },
//       { value: "back", label: "⬅ Back to Main Menu", trigger: "main_menu" },
//     ],
//   },

//   /* ================= COURSE DETAILS ================= */

//   {
//     id: "nvq3_info",
//     message:
//       "📘 Ophthalmic Optician (NVQ Level 03)\n\nDuration: 06 Months\n\nFocused training in ophthalmic dispensing with strong practical exposure.\n\n✔ Spectacle & Lens Dispensing\n✔ Measurements & Adjustments\n✔ Patient Care",
//     trigger: "after_course",
//   },

//   {
//     id: "assistant_info",
//     message:
//       "📘 Certificate in Ophthalmic Assistant\n\nDuration: 01 Year\n\nComprehensive opticianry training with hands-on clinical experience.\n\n✔ Practical Training\n✔ Industry Exposure\n✔ Certification",
//     trigger: "after_course",
//   },

//   {
//     id: "dip_info",
//     message:
//       "📘 Diploma in Optometry (NVQ Level 04)\n\nDuration: 02 Years\n\nAdvanced optometry and vision science education.\n\n✔ Clinical Practice\n✔ Research Methods\n✔ Advanced Optics",
//     trigger: "after_course",
//   },

//   {
//     id: "hdip_info",
//     message:
//       "📘 Higher Diploma in Optometry (NVQ Level 06)\n\nDuration: 02 Years & 06 Months\n\nProfessional-level optometry training with specialization.\n\n✔ Specialized Training\n✔ Clinical Rotations\n✔ Research Projects",
//     trigger: "after_course",
//   },

//   {
//     id: "fellow_info",
//     message:
//       "📘 Fellowship Courses\n\nDuration: 06 Months\n\nAdvanced specialization in modern optometric techniques.\n\n✔ Advanced Techniques\n✔ Clinical Applications\n✔ Specialization",
//     trigger: "after_course",
//   },

//   {
//     id: "workshop_info",
//     message:
//       "📘 Fellowship Workshops\n\nDuration: 1–5 Days\n\nIntensive hands-on workshops for professionals.\n\n✔ Skill Enhancement\n✔ Latest Technologies\n✔ Hands-on Training",
//     trigger: "after_course",
//   },

//   {
//     id: "nvq35_info",
//     message:
//       "📘 NVQ Level 3 & 5 – Ophthalmic Optician\n\nComprehensive NVQ training designed to build strong professional competencies.\n\n✔ Skill Enhancement\n✔ Clinical Applications\n✔ Hands-on Training",
//     trigger: "after_course",
//   },

//   {
//     id: "after_course",
//     message: "Would you like to explore another course or get contact details?",
//     trigger: "after_course_options",
//   },
//   {
//     id: "after_course_options",
//     options: [
//       { value: "more_courses", label: "📘 View Another Course", trigger: "course_menu" },
//       { value: "contact", label: "☎️ Contact Details", trigger: "contact_info" },
//       { value: "main", label: "🏠 Main Menu", trigger: "main_menu" },
//     ],
//   },

//   /* ================= LOCATION ================= */
//   {
//     id: "location_info",
//     message:
//       "📍 Location\n\nEye Care Institute\n932, Maradana Road,\nColombo 08,\nSri Lanka",
//     trigger: "location_next",
//   },
//   {
//     id: "location_next",
//     message: "Would you like course details or contact information?",
//     trigger: "location_options",
//   },
//   {
//     id: "location_options",
//     options: [
//       { value: "courses", label: "📘 View Courses", trigger: "course_menu" },
//       { value: "contact", label: "☎️ Contact Details", trigger: "contact_info" },
//     ],
//   },

//   /* ================= CONTACT ================= */
//   {
//     id: "contact_info",
//     message:
//       "011 268 2277\n076 101 0747\n077 344 0937\n ecinstitute@gmail.com\ninfo@eyecareinstitute.lk",
//     end: true,
//   },
// ];

const steps = [
  {
    id: "welcome",
    message: "Hello! 👋 Welcome to Eye Care Institute – College of Optometry & Vision Science.",
    trigger: "intro",
  },
  {
    id: "intro",
    message:
      "We offer nationally recognized NVQ and professional optometry programs designed to build a successful career in eye care.",
    trigger: "main_menu",
  },

  /* ================= MAIN MENU ================= */
  {
    id: "main_menu",
    options: [
      { value: "courses", label: "📘 View Courses", trigger: "course_menu" },
      { value: "location", label: "📍 View Location", trigger: "location_info" },
      { value: "contact", label: "☎️ Contact Details", trigger: "contact_info" },
    ],
  },

  /* ================= COURSE MENU ================= */
  {
    id: "course_menu",
    message: "Please select a course to view full details:",
    trigger: "course_options",
  },
  {
    id: "course_options",
    options: [
      { value: "nvq3", label: "Ophthalmic Optician (NVQ Level 03)", trigger: "nvq3_info" },
      { value: "assistant", label: "Certificate in Ophthalmic Assistant", trigger: "assistant_info" },
      { value: "hdip", label: "Higher Diploma in Optometry", trigger: "hdip_info" },
      { value: "back", label: "⬅ Back to Main Menu", trigger: "main_menu" },
    ],
  },

  /* ================= NVQ LEVEL 3 ================= */
  {
    id: "nvq3_info",
    message:
      "📘 Ophthalmic Optician (NVQ Level 03)\n\n" +
      "Focused training in ophthalmic dispensing including spectacle & lens selection, measurements, adjustments, and patient guidance.\n\n" +
      "🎓 Eligibility:\n" +
      "• Up to G.C.E. Ordinary Level\n" +
      "• OR Minimum 2 years industry experience\n\n" +
      "⏳ Duration:\n" +
      "• 06 Months\n\n" +
      "📚 Course Content:\n" +
      "Module 01 – Interpret the Prescription\n" +
      "Module 02 – Advise Customers in Selecting Frames\n" +
      "Module 03 – Select Lenses for Eyewear\n" +
      "Module 04 – Take Measurements to Fit Lenses\n" +
      "Module 05 – Assess the Final Product (Eyewear)\n" +
      "Module 06 – Deliver Products & Promote Sales\n" +
      "Module 07 – Maintain Records & Follow-up\n" +
      "Module 08 – Adjust & Repair Eyewear",
    trigger: "after_course",
  },

  /* ================= OPHTHALMIC ASSISTANT ================= */
  {
    id: "assistant_info",
    message:
      "📘 Certificate in Ophthalmic Assistant\n\n" +
      "A comprehensive one-year program for beginners, providing essential knowledge to assist Optometrists and Ophthalmologists.\n\n" +
      "🎓 Eligibility:\n" +
      "• Passed G.C.E. Ordinary Level\n" +
      "• OR Completed Certificate in Ophthalmic Optician (ECI)\n" +
      "• OR Minimum 5 years industry experience\n\n" +
      "⏳ Duration:\n" +
      "• 01 Year\n" +
      "• Includes written exam, oral test & practical exam\n\n" +
      "📚 Course Content:\n" +
      "Module 01 – General Science\n" +
      "Module 02 – Optics\n" +
      "Module 03 – Anatomy & Physiology of Eye\n" +
      "Module 04 – Common Eye Diseases\n" +
      "Module 05 – Clinical Optics & Refraction\n" +
      "Module 06 – Ophthalmic Equipment\n" +
      "Module 07 – Ophthalmic Lenses & Frames\n" +
      "Module 08 – Prescription & Ocular Measurements\n" +
      "Module 09 – Sales & Marketing",
    trigger: "after_course",
  },

  /* ================= HIGHER DIPLOMA ================= */
  {
    id: "hdip_info",
    message:
      "📘 Higher Diploma in Optometry\n\n" +
      "Advanced professional training in optometry focusing on clinical practice and eye care management.\n\n" +
      "🎓 Eligibility:\n" +
      "• Passed G.C.E. A/L with 3 passes (Physical or Biological Science)\n" +
      "• OR Competence in Certificate in Ophthalmic Assistant\n\n" +
      "⏳ Duration:\n" +
      "• Full Time – 02 Years\n\n" +
      "🔬 Scope:\n" +
      "Investigation, examination, diagnosis, and management of eye conditions.\n\n" +
      "📚 Course Structure:\n\n" +
      "📌 First Year – First Semester\n" +
      "• English\n" +
      "• Information Technology\n" +
      "• DIP101 – General Anatomy & Physiology\n" +
      "• DIP102 – Ocular Microbiology\n" +
      "• DIP103 – Biochemistry\n" +
      "• DIP104 – Optics (Geometrical & Physical)\n" +
      "• DIP105 – Ocular Anatomy & Physiology\n" +
      "• DIP106 – Pharmacology\n\n" +
      "📌 First Year – Second Semester\n" +
      "• DIP201 – Ocular Pathology I\n" +
      "• DIP202 – Clinical Procedure I\n" +
      "• DIP203 – Visual Optics\n" +
      "• DIP204 – Dispensing Optics\n" +
      "• DIP205 – Physiology of Vision\n" +
      "• DIP206 – General Medicine\n\n" +
      "📌 Second Year – Third Semester\n" +
      "• DIP301 – Clinical Procedure II\n" +
      "• DIP302 – Ocular Pathology II\n" +
      "• DIP303 – Binocular Vision\n" +
      "• DIP304 – Contact Lens\n" +
      "• DIP305 – Geriatric & Pediatric Optometry\n" +
      "• DIP306 – Low Vision\n\n" +
      "📌 Fourth Semester\n" +
      "• DIP401 – Public Health & Community Optometry\n" +
      "• DIP402 – Occupational Optometry\n" +
      "• DIP403 – Practice Management\n" +
      "• DIP404 – Research Methodology & Ethics\n" +
      "• Project Work\n" +
      "• Clinical Internship (OJT)\n\n" +
      "📌 Fifth Semester – Fellowship (06 Months)\n" +
      "Choose one:\n" +
      "• Contact Lens Dispensing\n" +
      "• Low Vision Rehabilitation\n" +
      "• Clinical Optometry\n" +
      "• Pediatric Optometry\n" +
      "• Binocular Vision\n" +
      "• Spectacle Dispensing\n\n" +
      "📝 Evaluation:\n" +
      "• Assignments\n" +
      "• Continuous Assessment\n" +
      "• Presentations\n" +
      "• Final Theory & Practical Exam",
    trigger: "after_course",
  },

  /* ================= AFTER COURSE ================= */
  {
    id: "after_course",
    message: "Would you like to explore another course or contact us?",
    trigger: "after_course_options",
  },
  {
    id: "after_course_options",
    options: [
      { value: "more_courses", label: "📘 View Another Course", trigger: "course_menu" },
      { value: "contact", label: "☎️ Contact Details", trigger: "contact_info" },
      { value: "main", label: "🏠 Main Menu", trigger: "main_menu" },
    ],
  },

  /* ================= LOCATION ================= */
  {
    id: "location_info",
    message:
      "📍 Eye Care Institute\n932, Maradana Road,\nColombo 08,\nSri Lanka",
    trigger: "main_menu",
  },

  /* ================= CONTACT ================= */
  {
    id: "contact_info",
    message:
      "☎️ Contact Us\n\n011 268 2277\n076 101 0747\n077 344 0937\n\n📧 ecinstitute@gmail.com\n📧 info@eyecareinstitute.lk",
    end: true,
  },
];







  const handleToggleChat = () => {
    if (!isOpen) {
      setIsOpen(true);
      setMinimized(false);
      if (conversation.length === 0) {
        startConversation();
      }
    } else {
      setMinimized(!minimized);
    }
  };

  const handleCloseChat = () => {
    setIsOpen(false);
    setMinimized(false);
  };

  const getStepById = (id) => {
    return steps.find(step => step.id === id);
  };

  const handleOptionSelect = (option) => {
    // Add user message
    const userMessage = { 
      text: option.label, 
      isUser: true,
      timestamp: new Date() 
    };
    setConversation(prev => [...prev, userMessage]);

    // Process the option trigger
    processStep(option.trigger);
  };

  const processStep = (stepId) => {
    const step = getStepById(stepId);
    if (!step) return;

    setIsTyping(true);

    // Simulate bot thinking
    setTimeout(() => {
      setIsTyping(false);

      // Add bot message if it exists
      if (step.message) {
        const botMessage = { 
          text: step.message, 
          isUser: false,
          timestamp: new Date() 
        };
        setConversation(prev => [...prev, botMessage]);
      }

      // Set current step for options
      setCurrentStepId(stepId);

      // If there's a trigger and it's not an end step, process the next step
      if (step.trigger && !step.end) {
        // Small delay before next message
        setTimeout(() => {
          processStep(step.trigger);
        }, 500);
      }
    }, 1500);
  };

  const getCurrentOptions = () => {
    const currentStep = getStepById(currentStepId);
    return currentStep?.options || [];
  };

  const startConversation = () => {
    setConversation([]);
    setCurrentStepId('welcome');
    processStep('welcome');
  };

  const resetConversation = () => {
    startConversation();
  };

  // Floating button only - chat window appears when clicked
  if (!isOpen) {
    return (
      <div className="chatbot-floating-button">
        <button className="floating-btn" onClick={handleToggleChat}>
          <span className="chat-icon">💬</span>
          <span className="chat-text">ECI Assistant</span>
        </button>
      </div>
    );
  }

  // Minimized state
  if (minimized) {
    return (
      <div className="chatbot-minimized">
        <button className="minimized-btn" onClick={handleToggleChat}>
          <span className="chat-icon">💬</span>
          <span>ECI Assistant</span>
        </button>
        <button className="close-btn" onClick={handleCloseChat}>×</button>
      </div>
    );
  }

  // Full chat window
  return (
    <div className="chatbot-window">
      <div className="chatbot-header">
        <div className="header-left">
          <span className="bot-avatar">🎓</span>
          <div>
            <h4>ECI Assistant</h4>
            <span className="status">Online</span>
          </div>
        </div>
        <div className="header-actions">
          <button className="header-btn" onClick={resetConversation} title="Restart">
            🔄
          </button>
          <button className="header-btn" onClick={handleToggleChat} title="Minimize">
            −
          </button>
          <button className="header-btn close" onClick={handleCloseChat} title="Close">
            ×
          </button>
        </div>
      </div>

      <div className="chatbot-messages">
        {conversation.map((msg, index) => (
          <div key={index} className={`message ${msg.isUser ? 'user' : 'bot'}`}>
            <div className="message-content">
              {msg.text.split('\n').map((line, i) => (
                <div key={i}>{line}</div>
              ))}
            </div>
            <div className="message-time">
              {msg.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </div>
          </div>
        ))}
        
        {isTyping && (
          <div className="message bot">
            <div className="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        )}
      </div>

      <div className="chatbot-options">
        {getCurrentOptions().map((option, index) => (
          <button
            key={index}
            className="option-btn"
            onClick={() => handleOptionSelect(option)}
          >
            {option.label}
          </button>
        ))}
        
        {getCurrentOptions().length === 0 && conversation.length > 2 && (
          <button className="option-btn restart" onClick={resetConversation}>
            Start New Conversation
          </button>
        )}
      </div>
    </div>
  );
};

export default Bot;